export const THUNK_CACHE_CONFIG = {
    DEFAULT_EXPIRE: 60000, // ms, время жизни кэша по умолчанию
};

export enum EThunkCacheTag {
    TABLE_REPORT = 'TABLE_REPORT',
    USER_FUNCTIONS = 'USER_FUNCTIONS'
}
